"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hautUploadImage = hautUploadImage;
exports.hautResults = hautResults;
exports.hautAnalyser = hautAnalyser;
const axios_1 = __importDefault(require("axios"));
const constant = __importStar(require("./haut.constant"));
const haut_constant_1 = require("./haut.constant");
let HAUT_ERRORS;
let HAUT_APP;
function analyseErrors(analysisResults, enableFailAnalysisOnQualityAlgo) {
    var _a, _b, _c, _d, _e;
    let errorMessages = '';
    let errorDetails = [];
    /*base case - fail analysis only when haut AI fails the analysis & get the error from HAUT AI API results call*/
    for (const skinComponent of analysisResults) {
        if (!skinComponent.is_ok && skinComponent.result.error) {
            errorMessages = skinComponent.result.error;
            break;
        }
    }
    /*case - fail analysis only when haut AI fails the analysis & get the error from quality Algo if brand has onboarded*/
    if (errorMessages && errorMessages.length > 0 && !enableFailAnalysisOnQualityAlgo) {
        for (const skinComponent of analysisResults) {
            const hasQualityAlgorithm = parseInt(skinComponent.algorithm_version_id) === haut_constant_1.HAUT_QUALITY_ALGORITHM_VERSION_ID;
            const hasProblems = ((_b = (_a = skinComponent.result) === null || _a === void 0 ? void 0 : _a.problems) === null || _b === void 0 ? void 0 : _b.length) > 0;
            if (skinComponent.is_ok && hasQualityAlgorithm && hasProblems) {
                const errorMessagesProblemsKeys = [...new Set(skinComponent.result.problems)];
                const errorMessagesProblems = errorMessagesProblemsKeys.map(item => haut_constant_1.HAUT_QUALITY_ALGORITHM_ERRORS[item] || item);
                if ((errorMessages && errorMessages.length > 0) || errorMessagesProblemsKeys.length >= haut_constant_1.HAUT_QUALITY_ALGORITHM_MAX_ERRORS) {
                    errorDetails = (_c = skinComponent === null || skinComponent === void 0 ? void 0 : skinComponent.result) === null || _c === void 0 ? void 0 : _c.problems.slice(0, haut_constant_1.HAUT_QUALITY_ALGORITHM_MAX_ERRORS);
                    errorMessages = errorMessagesProblems.slice(0, haut_constant_1.HAUT_QUALITY_ALGORITHM_MAX_ERRORS).join('|');
                    break;
                }
            }
        }
    }
    /*
      case - fail analysis when certain [threshold] of Quality Errors are met & show user top [threshold] errors
      eg: - fail analysis if more than 4 errors are there on analysis, show top 4 errors to user
    */
    if (enableFailAnalysisOnQualityAlgo) {
        for (const skinComponent of analysisResults) {
            const hasQualityAlgorithm = parseInt(skinComponent.algorithm_version_id) === haut_constant_1.HAUT_QUALITY_ALGORITHM_VERSION_ID;
            const hasProblems = ((_e = (_d = skinComponent.result) === null || _d === void 0 ? void 0 : _d.problems) === null || _e === void 0 ? void 0 : _e.length) > 0;
            if (skinComponent.is_ok && hasQualityAlgorithm && hasProblems) {
                const errorMessagesProblemsKeys = [...new Set(skinComponent.result.problems)];
                const errorMessagesProblems = errorMessagesProblemsKeys.map(item => haut_constant_1.HAUT_QUALITY_ALGORITHM_ERRORS[item] || item);
                if ((errorMessages && errorMessages.length > 0) || errorMessagesProblemsKeys.some(item => haut_constant_1.HAUT_FIXED_ERRORS.includes(item))) {
                    errorDetails = errorMessagesProblemsKeys.slice(0, haut_constant_1.HAUT_QUALITY_ALGORITHM_MAX_ERRORS);
                    errorMessages = errorMessagesProblems.slice(0, haut_constant_1.HAUT_QUALITY_ALGORITHM_MAX_ERRORS).join('|');
                    break;
                }
            }
        }
    }
    if (errorMessages) {
        const error = new Error();
        error.message = errorMessages;
        if (enableFailAnalysisOnQualityAlgo) {
            error['fixedErrorMessage'] = HAUT_APP === constant.APP_NAME.HAIR ? haut_constant_1.HAUT_FIXED_ERROR_MESSAGE_HAIR : haut_constant_1.HAUT_FIXED_ERROR_MESSAGE_SKIN;
        }
        error['details'] = errorDetails;
        throw error;
    }
    return analysisResults;
}
function hautUploadImage(imageData_1, userMeta_1) {
    return __awaiter(this, arguments, void 0, function* (imageData, userMeta, subjectId = '', meta, apidetails, requestTimeout = 18000) {
        try {
            console.time('[HAUT_UPLOAD_IMAGE_API_RESPONSE_TIME]');
            console.log(requestTimeout);
            let brandMeta = {
                brand: meta.brandName,
                locale: meta.brandLocale,
                version: meta.brandVersion,
            };
            if (meta === null || meta === void 0 ? void 0 : meta.journey_type) {
                brandMeta['journey_type'] = meta === null || meta === void 0 ? void 0 : meta.journey_type;
            }
            const analysisResponse = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: apidetails.HAUT_ANALYSE_API_URL,
                headers: {
                    'x-api-key': apidetails.apiKey,
                },
                // timeout: requestTimeout,
                data: {
                    meta: brandMeta,
                    data: Object.assign(Object.assign(Object.assign({ subjectId, username: userMeta.userId }, (userMeta.dob && { dob: userMeta.dob })), (userMeta.gender && { gender: userMeta.gender })), { imageData }),
                },
            });
            console.timeEnd('[HAUT_UPLOAD_IMAGE_API_RESPONSE_TIME]');
            return analysisResponse.data;
        }
        catch (error) {
            console.timeEnd('[HAUT_UPLOAD_IMAGE_API_RESPONSE_TIME]');
            if (error === null || error === void 0 ? void 0 : error.response)
                throw error === null || error === void 0 ? void 0 : error.response;
            else
                throw error;
        }
    });
}
function hautResults(hautMeta, meta, apidetails, hautAlgorithms, requestTimeout, options = haut_constant_1.DEFAULT_HAUT_RESULTS_OPTIONS, CONSUMER_HAUT_APP = '') {
    options = Object.assign(Object.assign({}, haut_constant_1.DEFAULT_HAUT_RESULTS_OPTIONS), options);
    if (CONSUMER_HAUT_APP)
        HAUT_APP = CONSUMER_HAUT_APP;
    console.log(requestTimeout);
    return new Promise(function (resolve, reject) {
        let counter = options.interval;
        let hautApiResponse = [];
        let brandMeta = {
            brand: meta.brandName,
            locale: meta.brandLocale,
            version: meta.brandVersion,
        };
        if (meta === null || meta === void 0 ? void 0 : meta.journey_type) {
            brandMeta['journey_type'] = meta === null || meta === void 0 ? void 0 : meta.journey_type;
        }
        const intervalId = setInterval(function () {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const skinAnalysisResponse = yield (0, axios_1.default)({
                        method: 'post',
                        responseType: 'json',
                        url: apidetails.HAUT_RESULTS_API_URL,
                        headers: {
                            'x-api-key': apidetails.apiKey,
                        },
                        // timeout: requestTimeout,
                        data: {
                            meta: brandMeta,
                            data: Object.assign({}, hautMeta),
                        },
                    });
                    hautApiResponse = analyseErrors(skinAnalysisResponse.data.data, options.enableFailAnalysisOnQualityAlgo);
                }
                catch (error) {
                    clearInterval(intervalId);
                    reject(error);
                }
                const algos = hautAlgorithms.map(item => {
                    if (item) {
                        if (item === null || item === void 0 ? void 0 : item.id) {
                            return Number(item === null || item === void 0 ? void 0 : item.id);
                        }
                        else {
                            return Number(item);
                        }
                    }
                });
                const getResultResponse = hautApiResponse.filter(result => algos.includes(result.algorithm_version_id));
                if (algos.length === getResultResponse.length || requestTimeout / counter <= 1) {
                    const hautAnalysisResults = { results: hautApiResponse };
                    clearInterval(intervalId);
                    resolve(hautAnalysisResults);
                }
                else {
                    counter = counter + options.interval;
                }
            });
        }, options.interval);
    });
}
function hautAnalyser(imageData_1, userMeta_1) {
    return __awaiter(this, arguments, void 0, function* (imageData, userMeta, subjectId = '', APP, meta, apidetails, hautAlgorithms, requestTimeout, options) {
        try {
            HAUT_APP = APP;
            if (APP === constant.APP_NAME.HAIR)
                HAUT_ERRORS = constant.HAUT_HAIR_ERRORS;
            if (APP === constant.APP_NAME.SKIN)
                HAUT_ERRORS = constant.HAUT_SKIN_ERRORS;
            console.time('[HAUT_Hair_ANALYSIS_RESPONSE_TIME]');
            const imageUploadResponse = yield hautUploadImage(imageData, userMeta, subjectId, meta, apidetails, requestTimeout);
            const data = yield hautResults(imageUploadResponse.data, meta, apidetails, hautAlgorithms, requestTimeout, options);
            const hairResults = data['results'].filter(item => item.result.image_type === constant.IMAGE_TYPE.HAIR_SLEFIE);
            return { result: hairResults, imageUploadResponse: imageUploadResponse.data };
        }
        catch (error) {
            console.timeEnd('[HAUT_SKIN_ANALYSIS_RESPONSE_TIME]');
            if (error === null || error === void 0 ? void 0 : error.response)
                throw error === null || error === void 0 ? void 0 : error.response;
            else
                throw error;
        }
    });
}
